// extracted by mini-css-extract-plugin
export var button = "_lc-2";
export var card = "_lc-0";
export var closeButtonContainer = "_lc-3";
export var iconContainer = "_lc-1";